
import { BaseNotificationManager } from './core/BaseNotificationManager';
import { ConfigManager } from './core/ConfigManager';
import { AttendanceNotificationService } from './attendance/AttendanceNotificationService';
import { TeacherNotification } from '@/services/db/teachers/types';
import { NotificationCategory, NotificationPriority } from '@/types/notifications';
import { TeacherNotificationService } from './teacher/TeacherNotificationService';
import { NotificationDeliveryManager } from './delivery/NotificationDeliveryManager';
import { UserRoutingService } from './routing/UserRoutingService';
import { UserNotificationRouting } from '@/types/notificationConfig';

export class NotificationManager extends BaseNotificationManager {
  private static instance: NotificationManager;
  private configManager: ConfigManager;
  public attendanceService: AttendanceNotificationService;
  private teacherService: TeacherNotificationService;
  private deliveryManager: NotificationDeliveryManager;
  private routingService: UserRoutingService;

  private constructor() {
    super('notifications');
    this.configManager = new ConfigManager();
    this.attendanceService = new AttendanceNotificationService();
    this.teacherService = new TeacherNotificationService();
    this.deliveryManager = new NotificationDeliveryManager();
    this.routingService = new UserRoutingService();
  }

  public static getInstance(): NotificationManager {
    if (!NotificationManager.instance) {
      NotificationManager.instance = new NotificationManager();
    }
    return NotificationManager.instance;
  }

  public createTeacherNotification(
    title: string,
    message: string,
    teacherId: string,
    teacherName: string | undefined,
    category: NotificationCategory,
    priority: NotificationPriority
  ): TeacherNotification {
    return this.teacherService.createTeacherNotification(
      title,
      message,
      teacherId,
      teacherName,
      category,
      priority
    );
  }

  public async deliverNotification(notification: any, specificUserId?: string): Promise<void> {
    return this.deliveryManager.deliverNotification(notification, specificUserId);
  }

  public getNotificationConfig = (category?: string) => {
    return this.configManager.getConfig(category);
  };

  public setNotificationConfig = (config: any, category: string) => {
    return this.configManager.setConfig(config, category);
  };

  public getUserRoutingConfig(): UserNotificationRouting[] {
    return this.routingService.getRecipients({} as any);
  }

  public setUserRoutingConfig(config: UserNotificationRouting): boolean {
    try {
      this.routingService.addRoutingConfig(config);
      return true;
    } catch (error) {
      console.error('Error setting user routing config:', error);
      return false;
    }
  }

  // Attendance-related methods delegation
  public processAttendancePatterns(attendanceRecords: any[]) {
    return this.attendanceService.processAttendancePatterns(attendanceRecords);
  }

  public sendAttendancePatternNotification(pattern: any, teacherName?: string) {
    return this.attendanceService.sendAttendancePatternNotification(pattern, teacherName);
  }

  public setAttendanceThresholds(absenceThreshold: number, latenessThreshold: number) {
    return this.attendanceService.setThresholds(absenceThreshold, latenessThreshold);
  }

  public getAttendanceThresholds() {
    return this.attendanceService.getThresholds();
  }
}
